import { j as s } from "./jsx-runtime-C5mzlN2N.js";
import { ArrowLeftIcon as i, ArrowRightIcon as l } from "lucide-react";
import { L as o } from "./chunk-BAXFHI7N-BVBOl9s0.js";
import { c } from "./cn-qaFjX9_3.js";
import { B as r } from "./index-DnQftvP4.js";
const f = ({
  prev: t,
  next: a,
  className: n
}) => {
  const e = "group transition-all p-5 space-x-1 transition-all hover:text-foreground";
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: c(
        "flex -mx-4 text-muted-foreground font-semibold",
        t ? "justify-between" : "justify-end",
        n
      ),
      children: [
        t && /* @__PURE__ */ s.jsx(r, { variant: "ghost", asChild: !0, children: /* @__PURE__ */ s.jsxs(o, { to: t.to, relative: "path", className: e, children: [
          /* @__PURE__ */ s.jsx(
            i,
            {
              className: "group-hover:motion-safe:animate-bounce-x-start",
              size: 12
            }
          ),
          /* @__PURE__ */ s.jsx("span", { className: "truncate", children: t.label })
        ] }) }),
        a && /* @__PURE__ */ s.jsx(r, { variant: "ghost", asChild: !0, children: /* @__PURE__ */ s.jsxs(o, { to: a.to, relative: "path", className: e, children: [
          /* @__PURE__ */ s.jsx("span", { className: "truncate ", children: a.label }),
          /* @__PURE__ */ s.jsx(
            l,
            {
              className: "group-hover:motion-safe:animate-bounce-x-end",
              size: 12
            }
          )
        ] }) })
      ]
    }
  );
};
export {
  f as P
};
//# sourceMappingURL=Pagination-DLPL5z77.js.map
